import { ApiKeys, fetcher } from '@insta-club/api';
import { renderLiList } from './create-elements';

const skipTime = 15;

export const closeMenus = (event) => {
    const menus = document.querySelectorAll('.vjs-oxy-menu');
    let clickedInsideMenu = false;
    menus.forEach(function (menu) {
        if (menu.contains(event.target)) {
            clickedInsideMenu = true;
        }
    });
    if (!clickedInsideMenu) {
        menus.forEach(function (menu) {
            menu.classList.remove('show');
        });
    }
};

export const hideMenus = () => {
    const menus = document.querySelectorAll('.vjs-oxy-menu');
    menus.forEach(function (menu) {
        menu.classList.remove('show');
    });
};

export const togglePause = (player) => () => {
    if (player?.paused()) {
        player?.play();
    } else {
        player?.pause();
    }
};

export const forwards = (player) => () => {
    if (isNaN(player.duration())) {
        return;
    }
    const currentVideoTime = player.currentTime();
    const duration = player.duration();
    const newTime = currentVideoTime + skipTime <= duration ? currentVideoTime + skipTime : duration;
    player.currentTime(newTime);
};

export const backwards = (player) => () => {
    if (isNaN(player.duration())) {
        return;
    }
    const currentVideoTime = player.currentTime();
    const newTime = currentVideoTime >= skipTime ? currentVideoTime - skipTime : 0;
    player.currentTime(newTime);
};

export const toggleFullScreen = (player) => () => {
    const isDOMFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
    );

    if (!isDOMFullscreen) {
        player.requestFullscreen?.();
    } else {
        document.exitFullscreen?.().catch(() => {});
    }
};

export const initQualityLevels = (player) => {
    const qualityLevels = player.qualityLevels();
    qualityLevels.on('addqualitylevel', function (event) {
        const ul = document.getElementById('ul-oxy-definition');
        const qualityLevel = event.qualityLevel;
        const pixels = qualityLevel.width > qualityLevel.height ? qualityLevel.height : qualityLevel.width;
        var name = '';
        if (qualityLevel.height >= 200 && qualityLevel.height < 300) {
            name = 240;
        } else if (qualityLevel.height >= 300 && qualityLevel.height < 400) {
            name = 360;
        } else if (qualityLevel.height >= 400 && qualityLevel.height < 600) {
            name = 480;
        } else if (qualityLevel.height >= 600 && qualityLevel.height <= 720) {
            name = 720;
        } else if (qualityLevel.height > 720 && qualityLevel.height <= 1080) {
            name = 1080;
        } else {
            name = pixels;
        }
        renderLiList({ title: name + 'p', item: qualityLevel }, ul, onQualitySelect(player));
    });
};

export const onQualitySelect = (player) => (quality) => {
    const qualityList = player.qualityLevels();
    for (let i = 0; i < qualityList.length; ++i) {
        const { height } = qualityList[i];
        qualityList[i].enabled = quality.height == height || quality === 'auto';
    }
};

export const changeSpeed = (player) => (speed) => {
    player.playbackRate(speed);
};

export const toggleMuted = (player, btnMute) => () => {
    player.muted(!player.muted());
    btnMute.current.innerHTML = player.muted()
        ? "<i class='fi fi-rr-volume-mute'></i>"
        : "<i class='fi fi-rr-volume'></i>";
};

export const toggleOtherParts = (show, otherParts) => {
    if (show) {
        otherParts.style.display = 'block';
        setTimeout(function () {
            otherParts.classList.add('show');
        }, 50);
    } else {
        otherParts.classList.remove('show');
        setTimeout(function () {
            otherParts.style.display = 'none';
        }, 300);
    }
};

export const sendWatchToServer = (time, episodeID) => {
    fetcher(ApiKeys.COURSES_EPISODE_DURATION, 'dashboard', 'POST', {
        body: {
            episode_id: episodeID,
            duration: time
        }
    });
};

